import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import ServiceDetail from '@/pages/ServiceDetail';
import SeasonalLighting from '@/pages/SeasonalLighting';
import Gallery from '@/pages/Gallery';
import ProjectPage from '@/pages/ProjectPage';
import About from '@/pages/About';
import ServiceAreas from '@/pages/ServiceAreas';
import CityPage from '@/pages/CityPage';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Estimate from '@/pages/Estimate';
import Admin from '@/pages/Admin';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Account from '@/pages/Account';
import ResetPassword from '@/pages/ResetPassword';
import NotFound from '@/pages/NotFound';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/auth/AuthContext';
import AuthCallback from '@/auth/AuthCallback';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  // Google OAuth returns here with #session_id=... — process it FIRST, before any route renders
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/seasonal-lighting" element={<SeasonalLighting />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:id" element={<ProjectPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/fort-worth" element={<CityPage citySlug="fort-worth" />} />
        <Route path="/burleson" element={<CityPage citySlug="burleson" />} />
        <Route path="/weatherford" element={<CityPage citySlug="weatherford" />} />
        <Route path="/granbury" element={<CityPage citySlug="granbury" />} />
        <Route path="/cleburne" element={<CityPage citySlug="cleburne" />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/estimate" element={<Estimate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <ScrollToTop />
        <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
